import { render } from "./DialogCanNotPurchaseAfterDeparture.vue?vue&type=template&id=4af1bb0c"
import script from "./DialogCanNotPurchaseAfterDeparture.vue?vue&type=script&lang=js"
export * from "./DialogCanNotPurchaseAfterDeparture.vue?vue&type=script&lang=js"
script.render = render

export default script